module.exports = __webpack_public_path__ + "img/sesamo.a24617ee.svg";